module.exports = __webpack_public_path__ + "static/media/PLScreenshot_Dashboard@2x.c62018c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/performanceLeader/PLScreenshot_Dashboard@2x.png
// module id = 225
// module chunks = 0